import { render, staticRenderFns } from "./MultiCreate.vue?vue&type=template&id=012d57e0&"
import script from "./MultiCreate.vue?vue&type=script&lang=js&"
export * from "./MultiCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports